import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, SweepstakeDetails, DrawingGroupTable } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';
import ProgressiveJackpot from '../Components/ProgressiveJackpot/ProgressiveJackpot';

const SecondChancePromotion = ({ user, config, sweep, cmsSourceFirebase, actions, match, loading }) => {
    const [promotionName, setPromotionName] = useState('Promotion Details');

    const telescriptSweepstakeDetails = getCMSObject('data.components.teleScripts.sweepstakeDetails.jsonBlock');
    const telescriptDrawingGroupTable = getCMSObject('data.components.teleScripts.drawingGroupTable.jsonBlock');

    const DrawingGroupTableWrapper = ({ drawingGroup, loggedIn }) => {
        return <DrawingGroupTable drawingGroup={drawingGroup} loggedIn={loggedIn} telescript={telescriptDrawingGroupTable} WinnerLink={WinnerLinkWrapper} />;
    };

    const searchParams = new URLSearchParams(window.location.search);
    const promotionId = searchParams.has('id') ? parseInt(searchParams.get('id')) : null;

    return (
        <Layout
            {...{
                user,
                sweep,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName ?? '',
                    },
                ],
            }}>
            <SweepstakeDetails
                {...{ user, sweep: sweep.sweeps?.find((val) => val.id === promotionId) ?? sweep.sweepDetails, actions, loading }}
                setPageTitle={setPromotionName}
                telescript={telescriptSweepstakeDetails}
                ProgressiveJackpot={ProgressiveJackpot}
                DrawingGroupTable={DrawingGroupTableWrapper}
            />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondChancePromotion);
